module.exports = __webpack_public_path__ + "static/media/image1.4eba1790.jpg";